// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-Container-ContainerHeader-__ContainerHeader-module___header","title":"src-components-Container-ContainerHeader-__ContainerHeader-module___title","icon":"src-components-Container-ContainerHeader-__ContainerHeader-module___icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/ContainerHeader/ContainerHeader.module.css
// module id = 79
// module chunks = 0